export default __webpack_public_path__ + "static/media/main-find.c99265f1.jpg";